module.exports = __webpack_public_path__ + "media/hph-23-02_research-community_2.0c153242.mp4";